import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from '@/pages/Home';
import Legal from '@/pages/Legal';
import { CookieConsent } from '@/components/CookieConsent';
import { initSmoothScroll } from '@/lib/smoothScroll';

function App() {
  useEffect(() => {
    const destroy = initSmoothScroll();
    return destroy;
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Legal page="privacy" />} />
          <Route path="/terms" element={<Legal page="terms" />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
